import ApiService from '@/api/http/ApiService';
import axios from 'axios';
import Filter from '@/interfaces/api/Filter';
import { Page } from '@/interfaces/api/Page';

export class PiggyApiService extends ApiService<any> {
  constructor() {
    super('piggy', 'v1');
  }

  public list(filter?: Filter) {
    return axios.get(`${this.getBaseUrl()}/rewards`, {params: filter});
  }
}
